import * as TE from 'fp-ts/TaskEither';
import { FetchError } from '../../utils/fetch';

export namespace ApiUtils {
  export const handleFetchError = (error: unknown) => error as FetchError;

  export const handleJson = <E = unknown, A = any>(body: Body): TE.TaskEither<E, A> =>
    TE.tryCatch<E, A>(
      () => body.json(),
      error => error as E,
    );
}
